import React from 'react';
import { Container, Box } from '@mui/material';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '../components/DashboardLayout';
import { AdminMedicationsTab } from '@pages/admin/AdminLibraryPage/AdminMedicationsTab';

export const AdminMedicationsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Container maxWidth={false} data-i-doc={PageIndices.ADMIN_MEDICATIONS}>
        <Box sx={{ width: '100%' }}>
          <AdminMedicationsTab />
        </Box>
      </Container>
    </DashboardLayout>
  );
};
